import { useStrings } from '../i18n/index.ts';
import { addWithChecks } from '../state/cart-sync.ts';
import type { AddressGateRequest } from '../state/gates.ts';
import { ScreenPlaceContext } from '../ui/Screen.tsx';
import { Sheet } from '../ui/Sheet.tsx';
import { NewAddressScreen } from './NewAddressScreen.tsx';
import '../styles/account.css';

/**
 * Лист адреса на первом «в корзину»: карта с булавкой, а товар, ради которого спросили,
 * ложится в корзину, как только точка выбрана.
 */
export function AddressGateSheet(props: { request: AddressGateRequest; onClose: () => void }) {
  const strings = useStrings();

  return (
    <Sheet size="large" label={strings.addressGateTitle} onClose={props.onClose}>
      {(close) => (
        <div className="sheet-body address-gate">
          <ScreenPlaceContext value={{ root: false, covered: false, onBack: close }}>
            <NewAddressScreen
              embedded
              title={strings.addressGateTitle}
              onSaved={() => {
                addWithChecks(props.request.item);
                close();
              }}
            />
          </ScreenPlaceContext>
        </div>
      )}
    </Sheet>
  );
}
